"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  "add-on-ads": {
    "name": "Ads Add-on",
    "description": "",
    "tags": []
  },
  "add-on-dedicated-ip": {
    "name": "Dedicated IP",
    "description": "",
    "tags": []
  },
  "add-on-lead-flows": {
    "name": "Lead Flows",
    "description": "",
    "tags": []
  },
  "add-on-portal": {
    "name": "Add New HubSpot Account",
    "description": "",
    "tags": []
  },
  "add-on-reporting": {
    "name": "Reporting Add-on",
    "description": "",
    "tags": []
  },
  "add-on-ssl": {
    "name": "SSL",
    "description": "",
    "tags": []
  },
  "add-on-transactional-email": {
    "name": "Transactional Email",
    "description": "",
    "tags": []
  },
  "add-on-website": {
    "name": "Website Platform",
    "description": "",
    "tags": []
  },
  "crm": {
    "name": "CRM",
    "description": "",
    "tags": []
  },
  "marketing-basic": {
    "name": "Marketing Basic",
    "description": "",
    "tags": []
  },
  "marketing-enterprise": {
    "name": "Marketing Enterprise",
    "description": "",
    "tags": []
  },
  "marketing-free": {
    "name": "Marketing Free",
    "description": "",
    "tags": []
  },
  "marketing-pro": {
    "name": "Marketing Pro",
    "description": "",
    "tags": []
  },
  "marketing-starter": {
    "name": "Marketing Starter",
    "description": "",
    "tags": []
  },
  "sales-free": {
    "name": "Sales Free",
    "description": "",
    "tags": []
  },
  "training-academy": {
    "name": "HubSpot Academy",
    "description": "",
    "tags": []
  },
  "training-crm": {
    "name": "CRM Training",
    "description": "",
    "tags": []
  },
  "training-growth-consulting": {
    "name": "Growth & Strategy Consulting",
    "description": "",
    "tags": []
  },
  "training-inbound-campaign": {
    "name": "Building an Inbound Campaign",
    "description": "",
    "tags": []
  },
  "training-project-consulting": {
    "name": "Project-based Consulting",
    "description": "",
    "tags": []
  },
  "training-sales-starter-kit": {
    "name": "CRM & Sales Starter Kit",
    "description": "",
    "tags": []
  },
  "training-technical-support": {
    "name": "Technical Support",
    "description": "",
    "tags": []
  },
  "cone": {
    "name": "Cone",
    "description": "",
    "tags": []
  },
  "pencil": {
    "name": "Pencil",
    "description": "",
    "tags": []
  },
  "plus": {
    "name": "Plus",
    "description": "",
    "tags": []
  },
  "warning": {
    "name": "Warning",
    "description": "",
    "tags": []
  },
  "success-green": {
    "name": "Success (green)",
    "description": "",
    "tags": []
  },
  "lock": {
    "name": "Lock",
    "description": "",
    "tags": []
  },
  "errors/icecream": {
    "name": "Ice Cream",
    "description": "",
    "tags": []
  },
  "errors/map": {
    "name": "Map",
    "description": "",
    "tags": []
  },
  "errors/hourglass": {
    "name": "Hourglass",
    "description": "",
    "tags": []
  },
  "shoppingbag": {
    "name": "Shopping bag",
    "description": "",
    "tags": []
  },
  "target": {
    "name": "Target",
    "description": "",
    "tags": []
  },
  "mobile-onboarding-account-ready": {
    "name": "Mobile Onboarding: Account ready",
    "description": "",
    "tags": []
  },
  "mobile-onboarding-connect-email": {
    "name": "Mobile Onboarding: Connect Email",
    "description": "",
    "tags": []
  },
  "mobile-onboarding-email-sent": {
    "name": "Mobile Onboarding: Email Sent",
    "description": "",
    "tags": []
  },
  "mobile-onboarding-embed-tracking-code": {
    "name": "Mobile Onboarding: Embed tracking code",
    "description": "",
    "tags": []
  },
  "mobile-onboarding-import-contacts": {
    "name": "Mobile Onboarding: Import Contacts",
    "description": "",
    "tags": []
  },
  "mobile-onboarding-powering-up": {
    "name": "Mobile Onboarding: Powering up",
    "description": "",
    "tags": []
  },
  "mobile-onboarding-welcome": {
    "name": "Mobile Onboarding: Welcome",
    "description": "",
    "tags": []
  },
  "api": {
    "name": "API",
    "description": "",
    "tags": []
  },
  "campaigns": {
    "name": "Campaigns",
    "description": "",
    "tags": []
  },
  "design-manager": {
    "name": "Design Manager",
    "description": "",
    "tags": []
  },
  "empty-state-charts": {
    "name": "Empty State Charts",
    "description": "",
    "tags": []
  },
  "forms-success": {
    "name": "Forms Success",
    "description": "",
    "tags": []
  },
  "forms": {
    "name": "Forms",
    "description": "",
    "tags": []
  },
  "global": {
    "name": "Global",
    "description": "",
    "tags": []
  },
  "idea": {
    "name": "Idea",
    "description": "",
    "tags": []
  },
  "note-widget": {
    "name": "Note Widget",
    "description": "",
    "tags": []
  },
  "product-library": {
    "name": "Product Library",
    "description": "",
    "tags": []
  },
  "products-shopping-cart": {
    "name": "Products Shopping Cart",
    "description": "",
    "tags": []
  },
  "social": {
    "name": "Social",
    "description": "",
    "tags": []
  },
  "success": {
    "name": "Success",
    "description": "",
    "tags": []
  },
  "text-snippet": {
    "name": "Text Snippet",
    "description": "",
    "tags": []
  },
  "unlock": {
    "name": "Unlock",
    "description": "",
    "tags": []
  },
  "vote-and-search": {
    "name": "Vote and Search",
    "description": "",
    "tags": []
  },
  "additional-hubspot-account-globe": {
    "name": "Additional HubSpot Account Globe",
    "description": "",
    "tags": []
  },
  "training-shop": {
    "name": "Training - Shop",
    "description": "",
    "tags": []
  },
  "training-truck": {
    "name": "Training - Truck",
    "description": "",
    "tags": []
  },
  "training-stand": {
    "name": "Training - Stand",
    "description": "",
    "tags": []
  },
  "dedicated-ip-board": {
    "name": "Dedicated IP Board",
    "description": "",
    "tags": []
  },
  "dedicated-ip-briefcase": {
    "name": "Dedicated IP Briefcase",
    "description": "",
    "tags": []
  },
  "designated-tech-support-laptop": {
    "name": "Designated Tech Support Laptop",
    "description": "",
    "tags": []
  },
  "designated-tech-support-monitor": {
    "name": "Designated Tech Support Monitor",
    "description": "",
    "tags": []
  },
  "designated-tech-support-ring": {
    "name": "Designated Tech Support Ring",
    "description": "",
    "tags": []
  },
  "hss-kit-book": {
    "name": "HSS Kit Book",
    "description": "",
    "tags": []
  },
  "hss-kit-clipboard": {
    "name": "HSS Kit Clipboard",
    "description": "",
    "tags": []
  },
  "transactional-email-bars": {
    "name": "Transactional Email Bars",
    "description": "",
    "tags": []
  },
  "transactional-email-envelope": {
    "name": "Transactional Email Envelope",
    "description": "",
    "tags": []
  },
  "transactional-email-web": {
    "name": "Transactional Email Web",
    "description": "",
    "tags": []
  },
  "website-platform-laptop": {
    "name": "Website Platform Laptop",
    "description": "",
    "tags": []
  },
  "website-platform-mobile": {
    "name": "Website Platform Mobile",
    "description": "",
    "tags": []
  },
  "website-platform-monitor": {
    "name": "Website Platform Monitor",
    "description": "",
    "tags": []
  },
  "gift": {
    "name": "Gift",
    "description": "",
    "tags": []
  },
  "all-conversations-complete": {
    "name": "All conversations complete",
    "description": "",
    "tags": []
  },
  "nps-question-thank-you": {
    "name": "NPS question thank you",
    "description": "",
    "tags": []
  },
  "nps-question": {
    "name": "NPS question",
    "description": "",
    "tags": []
  },
  "no-conversations": {
    "name": "No conversations",
    "description": "",
    "tags": []
  },
  "setup-complete": {
    "name": "Setup complete",
    "description": "",
    "tags": []
  },
  "successfully-submitted-question": {
    "name": "Successfully submitted question",
    "description": "",
    "tags": []
  },
  "successfully-connected-email": {
    "name": "Successfully connected email",
    "description": "",
    "tags": []
  },
  "events": {
    "name": "Events",
    "description": "",
    "tags": []
  },
  "keys": {
    "name": "Keys",
    "description": "",
    "tags": []
  },
  "knock-to-join": {
    "name": "Knock to join",
    "description": "",
    "tags": []
  },
  "open-door": {
    "name": "Open door",
    "description": "",
    "tags": []
  },
  "traffic-analytics": {
    "name": "Traffic analytics",
    "description": "",
    "tags": []
  },
  "transactions": {
    "name": "Transactions",
    "description": "",
    "tags": []
  },
  "email-browser": {
    "name": "Email browser",
    "description": "",
    "tags": []
  },
  "envelope-ring": {
    "name": "Envelope ring",
    "description": "",
    "tags": []
  },
  "envelope-trio": {
    "name": "Envelope trio",
    "description": "",
    "tags": []
  },
  "content-strategy": {
    "name": "Content strategy",
    "description": "",
    "tags": []
  },
  "deals": {
    "name": "Deals",
    "description": "",
    "tags": []
  },
  "leads": {
    "name": "Leads",
    "description": "",
    "tags": []
  },
  "predictive-lead-scoring": {
    "name": "Predictive Lead Scoring",
    "description": "",
    "tags": []
  },
  "sales-starter": {
    "name": "Sales Starter",
    "description": "",
    "tags": []
  },
  "teams": {
    "name": "Teams",
    "description": "",
    "tags": []
  },
  "workflows": {
    "name": "Workflows",
    "description": "",
    "tags": []
  },
  "sales-professional": {
    "name": "Sales Professional",
    "description": "",
    "tags": []
  },
  "marketplace-module": {
    "name": "Marketplace Module",
    "description": "",
    "tags": []
  },
  "marketplace-single-template": {
    "name": "Marketplace Single Template",
    "description": "",
    "tags": []
  },
  "marketplace-template-pack": {
    "name": "Marketplace Template Pack",
    "description": "",
    "tags": []
  },
  "announcement": {
    "name": "Announcement",
    "description": "",
    "tags": []
  },
  "moving-truck": {
    "name": "Moving Truck",
    "description": "",
    "tags": []
  },
  "qualify-leads": {
    "name": "Qualify Leads",
    "description": "",
    "tags": []
  },
  "copy-paste": {
    "name": "Copy and Paste",
    "description": "",
    "tags": []
  },
  "mobile-notify": {
    "name": "Mobile Notify",
    "description": "",
    "tags": []
  },
  "schedule": {
    "name": "Schedule",
    "description": "",
    "tags": []
  },
  "successful-send": {
    "name": "Successful Send",
    "description": "",
    "tags": []
  },
  "email-sending-domain": {
    "name": "Email Sending Domain",
    "description": "",
    "tags": []
  },
  "primary-hosting": {
    "name": "Primary Hosting",
    "description": "",
    "tags": []
  },
  "redirect-domain": {
    "name": "Redirect Domain",
    "description": "",
    "tags": []
  },
  "secondary-hosting": {
    "name": "Secondary Hosting",
    "description": "",
    "tags": []
  },
  "store-disabled": {
    "name": "Store Disabled",
    "description": "",
    "tags": []
  },
  "store": {
    "name": "Store",
    "description": "",
    "tags": []
  },
  "calling": {
    "name": "Calling",
    "description": "",
    "tags": []
  },
  "documents": {
    "name": "Documents",
    "description": "",
    "tags": []
  },
  "meetings": {
    "name": "Meetings",
    "description": "",
    "tags": []
  },
  "messages": {
    "name": "Messages",
    "description": "",
    "tags": []
  },
  "notifications": {
    "name": "Notifications",
    "description": "",
    "tags": []
  },
  "sequences": {
    "name": "Sequences",
    "description": "",
    "tags": []
  },
  "templates": {
    "name": "Templates",
    "description": "",
    "tags": []
  },
  "quotes": {
    "name": "Quotes",
    "description": "",
    "tags": []
  },
  "beta": {
    "name": "Beta",
    "description": "",
    "tags": []
  },
  "calling-small": {
    "name": "Calling (Small)",
    "description": "",
    "tags": []
  },
  "integrations": {
    "name": "Integrations",
    "description": "",
    "tags": []
  },
  "meetings-small": {
    "name": "Meetings (Small)",
    "description": "",
    "tags": []
  },
  "social-connected": {
    "name": "Social Connected",
    "description": "",
    "tags": []
  },
  "design-principle-clear": {
    "name": "Clear (Design Principle)",
    "description": "",
    "tags": []
  },
  "design-principle-collaborative": {
    "name": "Collaborative (Design Principle)",
    "description": "",
    "tags": []
  },
  "design-principle-human": {
    "name": "Human (Design Principle)",
    "description": "",
    "tags": []
  },
  "design-principle-inbound": {
    "name": "Inbound (Design Principle)",
    "description": "",
    "tags": []
  },
  "design-principle-integrated": {
    "name": "Integrated (Design Principle)",
    "description": "",
    "tags": []
  },
  "marketing-templates": {
    "name": "Marketing Templates",
    "description": "",
    "tags": []
  },
  "task-queues": {
    "name": "Task Queues",
    "description": "",
    "tags": []
  },
  "conversation-tags": {
    "name": "Conversation Tags",
    "description": "",
    "tags": []
  },
  "task": {
    "name": "Task",
    "description": "",
    "tags": []
  },
  "building": {
    "name": "Building",
    "description": "",
    "tags": []
  },
  "components": {
    "name": "Components",
    "description": "",
    "tags": []
  },
  "creating-ui-library": {
    "name": "Creating UI Library",
    "description": "",
    "tags": []
  },
  "documentation": {
    "name": "Documentation",
    "description": "",
    "tags": []
  },
  "evergreen": {
    "name": "Evergreen",
    "description": "",
    "tags": []
  },
  "styles": {
    "name": "Styles",
    "description": "",
    "tags": []
  },
  "avatar-harvey": {
    "name": "Avatar Harvey",
    "description": "",
    "tags": []
  },
  "avatar-hugo": {
    "name": "Avatar Hugo",
    "description": "",
    "tags": []
  },
  "avatar-jane": {
    "name": "Avatar Jane",
    "description": "",
    "tags": []
  },
  "avatar-mariah": {
    "name": "Avatar Mariah",
    "description": "",
    "tags": []
  },
  "avatar-michelle": {
    "name": "Avatar Michelle",
    "description": "",
    "tags": []
  },
  "instagram-publish": {
    "name": "Instagram Publish",
    "description": "",
    "tags": []
  },
  "bolt": {
    "name": "Bolt",
    "description": "",
    "tags": []
  },
  "import-file": {
    "name": "Import file",
    "description": "",
    "tags": []
  },
  "import-opt-out-list": {
    "name": "Import opt-out list",
    "description": "",
    "tags": []
  },
  "flowing-conversations": {
    "name": "Flowing conversations",
    "description": "",
    "tags": []
  },
  "conversations-inbox": {
    "name": "Conversations inbox",
    "description": "",
    "tags": []
  },
  "caution-connect-shared-email": {
    "name": "Caution Connect Shared Email",
    "description": "",
    "tags": []
  },
  "companies": {
    "name": "Companies",
    "description": "",
    "tags": []
  },
  "contacts": {
    "name": "Contacts",
    "description": "",
    "tags": []
  },
  "deals-small": {
    "name": "Deals Small",
    "description": "",
    "tags": []
  },
  "robot-small": {
    "name": "Robot Small",
    "description": "",
    "tags": []
  },
  "robot": {
    "name": "Robot",
    "description": "",
    "tags": []
  },
  "knowledge-base": {
    "name": "Knowledge Base",
    "description": "",
    "tags": []
  },
  "service-hub-professional": {
    "name": "Service Hub Professional",
    "description": "",
    "tags": []
  },
  "contacts-chat": {
    "name": "Contacts Chat",
    "description": "",
    "tags": []
  },
  "tickets": {
    "name": "Tickets",
    "description": "",
    "tags": []
  },
  "categories": {
    "name": "Categories",
    "description": "",
    "tags": []
  },
  "ticket-small": {
    "name": "Ticket Small",
    "description": "",
    "tags": []
  },
  "customer-experience": {
    "name": "Customer Experience",
    "description": "",
    "tags": []
  },
  "customer-feedback": {
    "name": "Customer Feedback",
    "description": "",
    "tags": []
  },
  "customer-support": {
    "name": "Customer Support",
    "description": "",
    "tags": []
  },
  "business-hours": {
    "name": "Business Hours",
    "description": "",
    "tags": []
  },
  "sunny": {
    "name": "Sunny",
    "description": "",
    "tags": []
  },
  "team-availability": {
    "name": "Team Availability",
    "description": "",
    "tags": []
  },
  "missed-goal": {
    "name": "Missed Goal",
    "description": "",
    "tags": []
  },
  "categories-color": {
    "name": "Categories Color",
    "description": "",
    "tags": []
  },
  "trophy": {
    "name": "Trophy",
    "description": "",
    "tags": []
  },
  "automated-testing": {
    "name": "Automated Testing",
    "description": "",
    "tags": []
  },
  "email-forwarding": {
    "name": "Email Forwarding",
    "description": "",
    "tags": []
  },
  "team": {
    "name": "Team",
    "description": "",
    "tags": []
  },
  "hss-extension": {
    "name": "HSS Extension",
    "description": "",
    "tags": []
  },
  "conversation-assignment": {
    "name": "Conversation Assignment",
    "description": "",
    "tags": []
  },
  "multiple-inboxes": {
    "name": "Multiple Inboxes",
    "description": "",
    "tags": []
  },
  "remove-branding": {
    "name": "Remove Branding",
    "description": "",
    "tags": []
  },
  "segmented-lists": {
    "name": "Segmented Lists",
    "description": "",
    "tags": []
  },
  "account-security": {
    "name": "Account Security",
    "description": "",
    "tags": []
  },
  "electronic-signature": {
    "name": "Electronic Signature",
    "description": "",
    "tags": []
  },
  "multiple-currency-revenue": {
    "name": "Multiple Currency Revenue",
    "description": "",
    "tags": []
  },
  "playbooks": {
    "name": "Playbooks",
    "description": "",
    "tags": []
  },
  "team-alignment": {
    "name": "Team Alignment",
    "description": "",
    "tags": []
  },
  "sales-enterprise": {
    "name": "Sales Enterprise",
    "description": "",
    "tags": []
  },
  "service-enterprise": {
    "name": "Service Enterprise",
    "description": "",
    "tags": []
  },
  "service-free": {
    "name": "Service Free",
    "description": "",
    "tags": []
  },
  "service-professional": {
    "name": "Service Professional",
    "description": "",
    "tags": []
  },
  "service-starter": {
    "name": "Service Starter",
    "description": "",
    "tags": []
  },
  "calculated-properties": {
    "name": "Calculated Properties",
    "description": "",
    "tags": []
  },
  "success-quota-met": {
    "name": "Success Quota Met",
    "description": "",
    "tags": []
  },
  "import-multiple-association": {
    "name": "Import multiple association",
    "description": "",
    "tags": []
  },
  "call-to-action": {
    "name": "Call To Action",
    "description": "",
    "tags": []
  },
  "ebook-download": {
    "name": "eBook Download",
    "description": "",
    "tags": []
  },
  "event-registration": {
    "name": "Event Registration",
    "description": "",
    "tags": []
  },
  "multiple-objects": {
    "name": "Multiple Objects",
    "description": "",
    "tags": []
  },
  "object": {
    "name": "Object",
    "description": "",
    "tags": []
  },
  "registration": {
    "name": "Registration",
    "description": "",
    "tags": []
  },
  "crm-onboarding-add-contact": {
    "name": "CRM Onboarding: Add Contact",
    "description": "",
    "tags": []
  },
  "crm-onboarding-integrations": {
    "name": "CRM Onboarding: Integrations",
    "description": "",
    "tags": []
  },
  "crm-onboarding-intro": {
    "name": "CRM Onboarding: Intro",
    "description": "",
    "tags": []
  },
  "crm-onboarding-organized": {
    "name": "CRM Onboarding: Organized",
    "description": "",
    "tags": []
  },
  "permission-sets": {
    "name": "Permission Sets",
    "description": "",
    "tags": []
  },
  "social-monitoring": {
    "name": "Social Monitoring",
    "description": "",
    "tags": []
  }
};
module.exports = exports["default"];